import { API } from "../../constant/apiConstant";

export const DrawService = {
 
  getActiveDraw: async () => {
    try {
      const response = await fetch(`${API.BASE_URL}/api/draws/active`, {
        method: "GET",
        credentials: "include",
        cache: "no-store",
        headers: {
          "Content-Type": "application/json",
        },
      });

      const json = await response.json();
      return json;
    } catch (error) {
      console.error("Error fetching active draw:", error);
      return {
        status: false,
        message: "Unable to fetch active draw",
      };
    }
  },

  
  getDraws: async (page = 1) => {
    try {
      const response = await fetch(`${API.BASE_URL}/api/draws?page=${page}`, {
        method: "GET",
        credentials: "include",
        cache: "no-store",
        headers: {
          "Content-Type": "application/json",
        },
      });

      const json = await response.json();
      return json;
    } catch (error) {
      console.error("Error fetching draw list:", error);
      return {
        status: false,
        data: [],
        totalPages: 1,
      };
    }
  },


  getDrawById: async (id) => {
    try {
      const response = await fetch(`${API.BASE_URL}/api/draws/${id}`, {
        method: "GET",
        credentials: "include",
        cache: "no-store",
        headers: {
          "Content-Type": "application/json",
        },
      });

      const json = await response.json();
      return json;
    } catch (error) {
      console.error("Error fetching draw details:", error);
      return {
        status: false,
        message: "Unable to fetch draw details",
      };
    }
  },
  getNextDraw: async (id) => {
    try {
      const response = await fetch(`${API.BASE_URL}/api/draws/nextdraw`, {
        method: "GET",
        credentials: "include",
        cache: "no-store",
        headers: {
          "Content-Type": "application/json",
        },
      });

      const json = await response.json();
      return json;
    } catch (error) {
      console.error("Error fetching draw details:", error);
      return {
        status: false,
        message: "Unable to fetch draw details",
      };
    }
  },

  getLiveDisplayDraw: async ({ includeResults = true } = {}) => {
    const controller = new AbortController();
    const timeout = setTimeout(() => controller.abort(), 10000);
    try {
      const response = await fetch(`${API.BASE_URL}/api/draws/live-display?include_results=${includeResults}`, {
        method: "GET",
        credentials: "include",
        cache: "no-store",
        signal: controller.signal,
        headers: {
          "Content-Type": "application/json",
        },
      });

      const json = await response.json();

      if (!response.ok) {
        throw Object.assign(new Error(json?.message || "Unable to fetch live draw details"), {status:response.status});
      }

      return json;
    } catch (error) {
      console.error("Error fetching live display draw:", error);
      throw error;
    } finally {
      clearTimeout(timeout);
    }
  }
};
